import uuid from 'uuid';

function tryParseJSON (data) {
  try {
    return JSON.parse(data)
  }
  catch (e) {
    return false
  }
}

export function invokeFunction (func, args, frame) {
  const msgID = uuid.v4()

  return new Promise((res) => {
    function responder (e) {
      //window.removeEventListener('message', responder)
      const result = tryParseJSON(e.data)

      if (!result) return

      if (result.msgID === msgID) {
        res(result.result)
      }
    }

    window.addEventListener('message', responder)

    frame.contentWindow.postMessage(JSON.stringify({
      func,
      args,
      msgID
    }), '*')

    
  })
}